var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M29.002 14.891c0 7.793-6.318 14.111-14.11 14.111C7.097 29.002.78 22.685.78 14.892.78 7.097 7.098.78 14.891.78c7.793 0 14.111 6.318 14.111 14.111zm-8.727-6.925V4.53l-2.844-.005c-2.814 0-4.741 1.718-4.741 4.873v2.717H9.508V15.8h3.182v9.458h3.807V15.8h3.647l.002-3.685h-3.65V9.76c0-1.067.296-1.794 1.827-1.794h1.952z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/face.d4587a584cc52700aafe92571101789d.svg";
export { ForwardRef as ReactComponent };